import { RootState } from '../../rootReducer';
import { IAddProSeatsInfo } from './interfaces';

export const getAddProSeatsInfo = (state: RootState): IAddProSeatsInfo => state.upgradeAccount.addProSeatsInfo;